export const XL_VARIANT = 'xl'
export const TABS_VARIANT = 'tabs'
export const TABS_ID_PREFIX = 'tab-slider'
export const TAB_QUOTE_STYLE = 'quote'
export const LENDING_VARIANT = 'lending-variant'

export const trustMarkersTypes = {
  trustpilot: { key: 'trustpilot', position: 'top-0 right-0 sm:top-[1%] sm:right-2' },
  bestCompany: { key: 'bestCompany', position: 'top-[20%] left-7' },
  consumerAffairs: {
    key: 'consumerAffairs',
    position: 'left-[20%] bottom-[5%] sm:bottom-[12%] sm:left-[15%]',
  },
  google: { key: 'google', position: 'bottom-[30%] right-2 sm:bottom-[35%] sm:right-4' },
}

export const TRUST_MARKER_IMAGES = {
  trustpilot: '/multi-site-assets/trustpilot.svg',
  bestCompany: '/multi-site-assets/best-company.svg',
  consumerAffairs: '/multi-site-assets/consumer-affairs.svg',
  google: '/multi-site-assets/google.svg',
}
